import { request } from '../request'

const userApi = '/sys/user'

export function getUserPageList(data) {
  return request({
    url: userApi,
    method: 'get',
    data
  })
}

export function getUserInfo(id) {
  return request({
    url: userApi + '/' + id,
    method: 'get'
  })
}

export function saveUserInfo(id, data) {
  return id ? modifyUserInfo(id, data) : addUserInfo(data)
}

export function addUserInfo(data) {
  return request({
    url: userApi,
    method: 'post',
    data
  })
}

export function modifyUserInfo(id, data) {
  return request({
    url: userApi + '/' + id,
    method: 'put',
    data
  })
}

export function removeUserInfo(id) {
  return request({
    url: userApi + '/' + id,
    method: 'delete'
  })
}

export function resetPassword(data) {
    return request({
      url: `${userApi}/password`,
      method: 'put',
      data
    })
}

const whiteListApi = '/website/whiteList'

export function getWhiteListPageList(data) {
  return request({
    url: whiteListApi,
    method: 'get',
    data
  })
}

export function getWhiteListInfo(id) {
  return request({
    url: `${whiteListApi}/${id}`,
    method: 'get'
  })
}

export function saveWhiteListInfo(id, data) {
  return id ? modifyWhiteListInfo(id, data) : addWhiteListInfo(data)
}

export function addWhiteListInfo(data) {
  return request({
    url: `${whiteListApi}`,
    method: 'post',
    data
  })
}

export function modifyWhiteListInfo(id, data) {
  return request({
    url: `${whiteListApi}/${id}`,
    method: 'put',
    data
  })
}

export function removeWhiteListInfo(id) {
  return request({
    url: `${whiteListApi}/${id}`,
    method: 'delete'
  })
}
